export class DatosExcelReserva {
    constructor(
        public  Smeid : number,
        public  SmeNombre : string,
        public  Desde : Date,
        public  Hasta : Date,
        public Medico : string,
        public medicoId: number,
        public empresaId: number,
        public todosServicios : boolean
    ) {    }

}